
import * as notice from "@/api/notice";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
@Component({
  components: {
    lsPagination,
    LsDialog,
    DatePicker,
  },
})
export default class SetMealList extends Vue {
  /** S Data **/

  apiNoticeLists = notice.apiNoticeLists;

  pager: RequestPaging = new RequestPaging();

  searchObj: Object = {
    state: "",
    subject: "",
    start_time: "",
    end_time: "",
    send_start_time: "",
    send_end_time: "",
  };
  /** E Data **/

  /** S Methods **/

  // 获取商城列表
  getSetMealLists(): void {
    this.pager.request({
      callback: this.apiNoticeLists,
      params: {
        ...this.searchObj,
      },
    });
  }


  // 删除商城
  async onSetMealDelete(row: any): Promise<void> {
    await notice.apiNoticeDelete({ id: row.id });
    this.getSetMealLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getSetMealLists();
  }

  // 去编辑商城
  toSetMealEdit(id: number | any): void {
    this.$router.push({
      path: "/notice/notice_detail",
      query: {
        id: id,
      },
    });
  }
//   发送
  toSendNotice(id: number | any){
    this.$confirm("是否发送通知？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        notice.apiNoticeSend({ id:id}).then((res) => {
        //   this.$message.success("发送成功");
          this.getSetMealLists();
        });
      })
      .catch(() => {
       
    })
    
  }
  /** E Methods **/

  /** S ods **/
  created() {
    this.getSetMealLists();
  }
}
